module.exports = __webpack_public_path__ + "img/folded.72b724d1.png";